/** Custom text for estimate/quote email and PDF APIs: trim and drop junk values. */
export function normalizeCustomTextForPayload(value: unknown): string {
  if (typeof value !== "string") {
    return "";
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }
  if (trimmed.toLowerCase() === "undefined") {
    return "";
  }
  return trimmed;
}
